// extracted by mini-css-extract-plugin
export default {"panel":"panel","grid":"grid","span2":"span2","footer":"footer"};